import { AbstractControl, ValidatorFn } from '@angular/forms';

export const mustMatch =
    (controlName: string, matchingControlName: string): ValidatorFn =>
    (control: AbstractControl) => {
        const matchedControl: AbstractControl | null = control.get(controlName);
        const matchingControl: AbstractControl | null = control.get(matchingControlName);
        let errors = null;
        if (!matchedControl) {
            return { mustMatch: { matchedControlMissing: true } };
        }
        if (!matchingControl) {
            return { mustMatch: { matchingControlMissing: true } };
        }
        if (matchingControl.errors) {
            let formerMustMatch;
            // eslint-disable-next-line @typescript-eslint/no-unused-vars, prefer-const
            ({ mustMatch: formerMustMatch, ...errors } = matchingControl.errors);
            if (Object.keys(errors).length === 0) {
                errors = null;
            }
        }
        if (matchedControl.value !== matchingControl.value) {
            errors = { ...errors, mustMatch: true };
        }
        matchingControl.setErrors(errors);
        return null;
    };
